import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { DeviceResetActionTypes, DeviceResetActions } from '../actions/device-reset.actions';
import {DevicesService} from '../../../services/devices.service';
import * as featureActions from '../../index';
import * as fromStore from '../../../store';
import { Store } from '@ngrx/store';



@Injectable()
export class DeviceResetEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceService = inject(DevicesService);

  constructor() {}

  LoadDeviceResets$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceResetActionTypes.LoadDeviceResets),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        Devices: action.payload.Devices,
      };
      if (user.authority === 2) {
        return this.deviceService.ResetDevice(params).pipe(
          map((res: any) => {
            if (res.Flag) {
              return new featureActions.UpsertDeviceReset(res);
            } else {
              return new featureActions.DeviceResetsFail();
            }
            // throw new Error('update fail');
          }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
          catchError((error) => {
            return of(new featureActions.DeviceResetsFail());
          })
        );
      } else {
        return of(new featureActions.DeviceResetsFail());
      }
    })
  ));
  ReadResetDeviceLog$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceResetActionTypes.GetResetDeviceLog),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = {
        otp: user.otp,
      };
      if (user.authority === 2) {
        return this.deviceService.ReadResetDeviceLog(params).pipe(
          map((res: any) => {
            if (res.result) {
              return new featureActions.GetResetDeviceLogSuccess(res.msg);
            } else {
              return new featureActions.GetResetDeviceLogFail();
            }
            // throw new Error('update fail');
          }),
          // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
          catchError((error) => {
            return of(new featureActions.GetResetDeviceLogFail());
          })
        );
      } else {
        return of(new featureActions.GetResetDeviceLogFail());
      }
    })
  ));
}
